<template>
<div class="footer">
    <div class="footer-logo"><img :src="setting.siteLogo" @click="goCate_('home')"/></div>
      <div class="footer-menu">
          <ul>

              <li  @click="goCate_('home')">
                  <a href="javascript:;">
                      <div class="menu-name">首页</div>
                      <div class="menu-short-title">home page</div>
                      <i></i>
                  </a>
              </li>
              <li v-for="(item,index) in bottomCmsCategoryList" :class="getCateClass(item)" @click="goCate_(item)">
                  <a href="javascript:;">
                      <div class="menu-name">{{item.categoryName}}</div>
                      <div class="menu-short-title">{{item.code}}{{item.categoryTitle}}</div>
                      <i></i>
                  </a>
              </li>
          </ul>
      </div>
      <div class="contant-us">
          <div class="qrcode"><img :src="setting.wexinCode"/></div>
          <div class="qrcode-right">
              <div class="txt1">客服电话</div>
              <div class="txt2">{{setting.phone1}}</div>
          </div>
      </div>
</div>


</template>
<script>
    import {settingInfo_, categoryTree_, goCate_, goAdv_} from '@/components/js/app'
export default {
    props: {

    },
    data() {
      return {
          currentCateId:0,
          setting:{},
          bottomCmsCategoryList:[],
          categoryInfo:{}
      }
    },

    created() {
        this.currentCateId = this.$route.query.cateId;
          this.$nextTick(()=>{
              this.categoryTree();
              this.settingInfo();
          })
    },
    methods : {
        goCate_,
        goAdv_,
        // 底部导航
       categoryTree() {
           categoryTree_((res) => {
               if (res.code == 1) {
                    this.bottomCmsCategoryList = res.data;

                   for (let i = 0; i < res.data.length; i++) {
                       if (res.data[i].id==this.currentCateId) {
                           this.categoryInfo = res.data[i];
                           return;
                       }

                       if (res.data[i].children) {
                           let child = res.data[i].children;

                           for (let j = 0; j < child.length; j++) {
                               if (child[j].id==this.currentCateId) {
                                   this.categoryInfo = child[j];
                                   break;
                               }


                               if (child[j].children) {
                                   for (let k = 0; k < child[j].children.length; k++) {
                                      if (child[j].children[k].id==this.currentCateId) {
                                          this.categoryInfo = child[j].children[k];
                                          break;
                                      }
                                  }
                               }
                           }
                       }
                   }

                } else {
                    this.$message.error(res.message);
                }
           }, false);
       },
       // 配置信息
      settingInfo() {
          settingInfo_((res) => {
              if (res.code == 1) {
                  this.setting = res.data;
              } else {
                  this.$message.error(res.message);
              }
          }, false);
       },
        getCateClass(item) {
            if (!item) {
                return "";
            }
             if (item == 'home' && this.currentCateId == 0) {
                 return "on";
             } else if(this.categoryInfo.superIds) {

                 let split = this.categoryInfo.superIds.split(",");

                 if (split.indexOf(item.id + "") != -1) {
                     return "on";
                 }
             }
             return "";

         },
     }
}
</script>
<style scoped>
.footer{height: 160px;border-top: #ef8e27 10px solid;display: flex;background: #e66b28;
    width: 100%;justify-content: space-between;align-items: center;}
.footer-logo{width: 160px;height: 42px;margin-left: 80px;}
.footer-logo img{object-fit: cover;height: 100%;width: 100%;}
.footer-menu{flex-shrink: 1;height: 100%;}
.footer-menu ul{display: flex;justify-content: center;align-items: center;height: 100%;}
.footer-menu li{height: 100%;cursor: pointer;}
.footer-menu li.on{height: 100%;background: #ef8e27;}
.footer-menu li a{display: block;color: #FFFFFF;padding: 0px 35px;margin-top: 65px;text-align: center;position: relative;}
.footer-menu li.on a{margin-top: 35px;}

.menu-name {font-size: 16px;}
.menu-short-title{font-size: 12px;display: none;}
.footer-menu li.on a .menu-short-title{display: block;}
.footer-menu li a i{display: none;}


.contant-us{display: flex;margin-right: 60px;align-items: center;}
.contant-us .qrcode{width: 60px;height: 60px;margin-right: 10px;}
.contant-us .qrcode img{height: 100%;width: 100%;object-fit: cover;}
.contant-us .qrcode-right{color: #FFFFFF;font-size: 16px;flex: 1;width: 120px;}
.qrcode-right .txt1{}
.qrcode-right .txt2{}



@media (max-width:1799px){
}
@media (max-width:1399px){
    .footer-menu li a{padding: 0px 20px;}
}
@media (max-width:1199px){
    .footer{height: 100px;border-top: #ef8e27 10px solid;display: flex;background: #e66b28;
        width: 100%;justify-content: space-between;align-items: center;}


    .footer-menu li a{display: block;color: #FFFFFF;padding: 0px 10px;margin-top: 35px;text-align: center;}
    .footer-menu li.on a{margin-top: 15px;}
    .menu-name{font-size: 14px;}

    .contant-us{display: flex;margin-right: 10px;align-items: center;}
    .contant-us .qrcode{width: 50px;height: 50px;margin-right: 10px;}
    .contant-us .qrcode-right{color: #FFFFFF;font-size: 14px;}
}
@media (max-width:993px){
    .footer{height: auto;width: 100%;flex-direction: column;}
    .footer-logo{margin-top: 30px;margin-left: 0px;}
    .footer-menu{width: 100%;padding-bottom: 20px;}
    .footer-menu ul{display: block;width: 100%;}
    .footer-menu li a{width: 100%;text-align: left;padding:15px;margin: 0px;border-bottom: #CCCCCC 1px solid;}
    .footer-menu li.on a{padding:15px;margin: 0px;}
    .footer-menu li.on{height: 100%;background: none;}
    .footer-menu li.on a .menu-short-title{display: none;}


    .footer-menu li a i{width:9px; height:9px; position:absolute; right:8px; top:50%; margin-top:-4px; display:block; transition:all 0.3s ease-in-out;}
    .footer-menu li a i:after{content:""; width:1px; height:9px; position:absolute; left:4px; top:0; background:rgba(255,255,255,0.3)}
    .footer-menu li a i:before{content:""; width:9px; height:1px; position:absolute; top:4px; left:0; background:rgba(255,255,255,0.3)}

    .contant-us{display: none;}
}

@media (max-width:767px){

}



</style>
